import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../config/axios";

import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import Details from "../../components/dashboard/paymentPartials/Details";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";

const PaymentsDetailsPage = () => {
  const { id } = useParams(); // ✅ /payments/:id
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchPaymentDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/dashboard/payments/${id}`);
      setPayment(data?.item);
      setError("");
    } catch (err) {
      console.error("Failed to load payment details:", err);
      setError("Failed to load payment details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPaymentDetails();
    }
  }, [id]);

  return (
    <>
      <PageWrapper loading={loading} className="bg-bg min-h-screen">
        {loading && <FullScreenLoading />}
        <Header code={null} />
        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true}
            component={
              !loading && error ? (
                <ApiErrorMessage
                  message1="Failed to load payment details"
                  message2="Please check your connection and try again."
                />
              ) : !loading && !payment ? (
                <NoItemsFound
                  message1="No Payment Found"
                  message2="Payment details not available."
                />
              ) : (
                <Details payment={payment} />
              )
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PaymentsDetailsPage;
